// Product translations - Frontend only, no database changes needed
// Auto-generated from database export
// Structure: { productId: { fieldName: { en: "...", es: "...", de: "...", it: "..." } } }
// Or for generic field translations: { fieldName: { en: "...", es: "...", de: "...", it: "..." } }

export const productTranslations = {
  // Generic field translations (applied to all products)
  // These translate common product field values that come from the API
  fields: {
    // Variant types
    "Base": {
      en: "Base",
      es: "Base",
      de: "Basis",
      it: "Base",
    },
    "Seguinte": {
      en: "Extension",
      es: "Seguinte",
      de: "Erweiterung",
      it: "Successiva",
    },
    // Units and common terms
    "cm": {
      en: "cm",
      es: "cm",
      de: "cm",
      it: "cm",
    },
    "kg": {
      en: "kg",
      es: "kg",
      de: "kg",
      it: "kg",
    },
    "—": {
      en: "—",
      es: "—",
      de: "—",
      it: "—",
    },
    // Status
    "Sob consulta": {
      en: "On request",
      es: "Bajo consulta",
      de: "Auf Anfrage",
      it: "Su richiesta",
    },
    "IVA incluído": {
      en: "VAT included",
      es: "IVA incluido",
      de: "MwSt. inklusive",
      it: "IVA inclusa",
    },
    "IVA incl.": {
      en: "VAT incl.",
      es: "IVA incl.",
      de: "MwSt. inkl.",
      it: "IVA incl.",
    },
    "A partir de": {
      en: "From",
      es: "Desde",
      de: "Ab",
      it: "A partire da",
    },
  },

  // Product-specific translations (by product ID or SKU)
  products: {
  "1": {
    "name": {
      "en": "Bancada de Trabalho",
      "es": "Bancada de Trabalho",
      "de": "Bancada de Trabalho",
      "it": "Bancada de Trabalho"
    },
    "description": {
      "en": "Bancada multiuso para oficinas, embalagem, montagem, classificação, preparação de pedidos, etc.",
      "es": "Bancada multiuso para oficinas, embalagem, montagem, classificação, preparação de pedidos, etc.",
      "de": "Bancada multiuso para oficinas, embalagem, montagem, classificação, preparação de pedidos, etc.",
      "it": "Bancada multiuso para oficinas, embalagem, montagem, classificação, preparação de pedidos, etc."
    },
    "features": {
      "feature_Bancada multiuso para oficinas, embalagem, montagem, classificação, preparação de pedidos, etc.": {
        "en": "Bancada multiuso para oficinas, embalagem, montagem, classificação, preparação de pedidos, etc.",
        "es": "Bancada multiuso para oficinas, embalagem, montagem, classificação, preparação de pedidos, etc.",
        "de": "Bancada multiuso para oficinas, embalagem, montagem, classificação, preparação de pedidos, etc.",
        "it": "Bancada multiuso para oficinas, embalagem, montagem, classificação, preparação de pedidos, etc."
      }
    },
    "categories": [
      "bancada-de-trabalho"
    ]
  },
  "2": {
    "name": {
      "en": "Cantilever Carga Média",
      "es": "Cantilever Carga Média",
      "de": "Cantilever Carga Média",
      "it": "Cantilever Carga Média"
    },
    "description": {
      "en": "Armazenamento horizontal para cargas médias.\\nSistema evolutivo formado por colunas que são colocadas lado a lado em intervalos máximos de 1000mm até obter o comprimento desejado. Esta estante permite guardar tubos, perfis e outros objetos pesados ​​e compridos. Colunas e pés em azul ral 5005 – braços e batentes em cinza ral 7035.",
      "es": "Armazenamento horizontal para cargas médias.\\nSistema evolutivo formado por colunas que são colocadas lado a lado em intervalos máximos de 1000mm até obter o comprimento desejado. Esta estante permite guardar tubos, perfis e outros objetos pesados ​​e compridos. Colunas e pés em azul ral 5005 – braços e batentes em cinza ral 7035.",
      "de": "Armazenamento horizontal para cargas médias.\\nSistema evolutivo formado por colunas que são colocadas lado a lado em intervalos máximos de 1000mm até obter o comprimento desejado. Esta estante permite guardar tubos, perfis e outros objetos pesados ​​e compridos. Colunas e pés em azul ral 5005 – braços e batentes em cinza ral 7035.",
      "it": "Armazenamento horizontal para cargas médias.\\nSistema evolutivo formado por colunas que são colocadas lado a lado em intervalos máximos de 1000mm até obter o comprimento desejado. Esta estante permite guardar tubos, perfis e outros objetos pesados ​​e compridos. Colunas e pés em azul ral 5005 – braços e batentes em cinza ral 7035."
    },
    "features": {
      "feature_Armazenamento horizontal para cargas médias.": {
        "en": "Armazenamento horizontal para cargas médias.",
        "es": "Armazenamento horizontal para cargas médias.",
        "de": "Armazenamento horizontal para cargas médias.",
        "it": "Armazenamento horizontal para cargas médias."
      },
      "feature_Sistema evolutivo formado por colunas que são colocadas lado a lado em intervalos máximos de 1000mm até obter o comprimento desejado. Esta estante permite guardar tubos, perfis e outros objetos pesados ​​e compridos. Colunas e pés em azul ral 5005 – braços e batentes em cinza ral 7035.": {
        "en": "Sistema evolutivo formado por colunas que são colocadas lado a lado em intervalos máximos de 1000mm até obter o comprimento desejado. Esta estante permite guardar tubos, perfis e outros objetos pesados ​​e compridos. Colunas e pés em azul ral 5005 – braços e batentes em cinza ral 7035.",
        "es": "Sistema evolutivo formado por colunas que são colocadas lado a lado em intervalos máximos de 1000mm até obter o comprimento desejado. Esta estante permite guardar tubos, perfis e outros objetos pesados ​​e compridos. Colunas e pés em azul ral 5005 – braços e batentes em cinza ral 7035.",
        "de": "Sistema evolutivo formado por colunas que são colocadas lado a lado em intervalos máximos de 1000mm até obter o comprimento desejado. Esta estante permite guardar tubos, perfis e outros objetos pesados ​​e compridos. Colunas e pés em azul ral 5005 – braços e batentes em cinza ral 7035.",
        "it": "Sistema evolutivo formado por colunas que são colocadas lado a lado em intervalos máximos de 1000mm até obter o comprimento desejado. Esta estante permite guardar tubos, perfis e outros objetos pesados ​​e compridos. Colunas e pés em azul ral 5005 – braços e batentes em cinza ral 7035."
      }
    },
    "categories": [
      "Racks de Canto",
      "Medium Racks"
    ]
  },
  "3": {
    "name": {
      "en": "Cantilever ligeiro Medium Racks",
      "es": "Cantilever ligeiro Medium Racks",
      "de": "Cantilever ligeiro Medium Racks",
      "it": "Cantilever ligeiro Medium Racks"
    },
    "description": {
      "en": "Estante cantilever para armazenamento horizontal de cargas leves.\\nAté 80 kg por par de braços.",
      "es": "Estante cantilever para armazenamento horizontal de cargas leves.\\nAté 80 kg por par de braços.",
      "de": "Estante cantilever para armazenamento horizontal de cargas leves.\\nAté 80 kg por par de braços.",
      "it": "Estante cantilever para armazenamento horizontal de cargas leves.\\nAté 80 kg por par de braços."
    },
    "features": {
      "feature_Estante cantilever para armazenamento horizontal de cargas leves.": {
        "en": "Estante cantilever para armazenamento horizontal de cargas leves.",
        "es": "Estante cantilever para armazenamento horizontal de cargas leves.",
        "de": "Estante cantilever para armazenamento horizontal de cargas leves.",
        "it": "Estante cantilever para armazenamento horizontal de cargas leves."
      },
      "feature_Até 80 kg por par de braços.": {
        "en": "Até 80 kg por par de braços.",
        "es": "Até 80 kg por par de braços.",
        "de": "Até 80 kg por par de braços.",
        "it": "Até 80 kg por par de braços."
      }
    },
    "categories": [
      "Racks de Canto",
      "Lite Racks"
    ]
  },
  "4": {
    "name": {
      "en": "Porta Cabides Lite Racks",
      "es": "Porta Cabides Lite Racks",
      "de": "Porta Cabides Lite Racks",
      "it": "Porta Cabides Lite Racks"
    },
    "description": {
      "en": "A solução ideal para guardar roupas penduradas.",
      "es": "A solução ideal para guardar roupas penduradas.",
      "de": "A solução ideal para guardar roupas penduradas.",
      "it": "A solução ideal para guardar roupas penduradas."
    },
    "features": {
      "feature_A solução ideal para guardar roupas penduradas.": {
        "en": "A solução ideal para guardar roupas penduradas.",
        "es": "A solução ideal para guardar roupas penduradas.",
        "de": "A solução ideal para guardar roupas penduradas.",
        "it": "A solução ideal para guardar roupas penduradas."
      }
    },
    "categories": [
      "Lite Racks"
    ]
  },
  "5": {
    "name": {
      "en": "Porta Jantes Lite Racks",
      "es": "Porta Jantes Lite Racks",
      "de": "Porta Jantes Lite Racks",
      "it": "Porta Jantes Lite Racks"
    },
    "description": {
      "en": "Solução especializada para armazenamento de jantes.",
      "es": "Solução especializada para armazenamento de jantes.",
      "de": "Solução especializada para armazenamento de jantes.",
      "it": "Solução especializada para armazenamento de jantes."
    },
    "features": {
      "feature_Solução especializada para armazenamento de jantes.": {
        "en": "Solução especializada para armazenamento de jantes.",
        "es": "Solução especializada para armazenamento de jantes.",
        "de": "Solução especializada para armazenamento de jantes.",
        "it": "Solução especializada para armazenamento de jantes."
      }
    },
    "categories": [
      "Lite Racks"
    ]
  },
  "6": {
    "name": {
      "en": "Porta Pneus Medium Racks",
      "es": "Porta Pneus Medium Racks",
      "de": "Porta Pneus Medium Racks",
      "it": "Porta Pneus Medium Racks"
    },
    "description": {
      "en": "Porta-pneus adaptável às suas necessidades. Até 160 kg por nível.",
      "es": "Porta-pneus adaptável às suas necessidades. Até 160 kg por nível.",
      "de": "Porta-pneus adaptável às suas necessidades. Até 160 kg por nível.",
      "it": "Porta-pneus adaptável às suas necessidades. Até 160 kg por nível."
    },
    "features": {
      "feature_Porta-pneus adaptável às suas necessidades. Até 160 kg por nível.": {
        "en": "Porta-pneus adaptável às suas necessidades. Até 160 kg por nível.",
        "es": "Porta-pneus adaptável às suas necessidades. Até 160 kg por nível.",
        "de": "Porta-pneus adaptável às suas necessidades. Até 160 kg por nível.",
        "it": "Porta-pneus adaptável às suas necessidades. Até 160 kg por nível."
      }
    },
    "categories": [
      "Medium Racks"
    ]
  },
  "7": {
    "name": {
      "en": "Porta Pneus Lite Racks",
      "es": "Porta Pneus Lite Racks",
      "de": "Porta Pneus Lite Racks",
      "it": "Porta Pneus Lite Racks"
    },
    "description": {
      "en": "Solução especializada para armazenamento de pneus.",
      "es": "Solução especializada para armazenamento de pneus.",
      "de": "Solução especializada para armazenamento de pneus.",
      "it": "Solução especializada para armazenamento de pneus."
    },
    "features": {
      "feature_Solução especializada para armazenamento de pneus.": {
        "en": "Solução especializada para armazenamento de pneus.",
        "es": "Solução especializada para armazenamento de pneus.",
        "de": "Solução especializada para armazenamento de pneus.",
        "it": "Solução especializada para armazenamento de pneus."
      }
    },
    "categories": [
      "Lite Racks"
    ]
  },
  "8": {
    "name": {
      "en": "Medium Racks Z1000",
      "es": "Medium Racks Z1000",
      "de": "Medium Racks Z1000",
      "it": "Medium Racks Z1000"
    },
    "description": {
      "en": "Estante de carga média com capacidade de carga extra.\\nAté 850 kg por nível.\\nTAMPOS DE AGLOMERADO DE 19 MM INCLUÍDOS",
      "es": "Estante de carga média com capacidade de carga extra.\\nAté 850 kg por nível.\\nTAMPOS DE AGLOMERADO DE 19 MM INCLUÍDOS",
      "de": "Estante de carga média com capacidade de carga extra.\\nAté 850 kg por nível.\\nTAMPOS DE AGLOMERADO DE 19 MM INCLUÍDOS",
      "it": "Estante de carga média com capacidade de carga extra.\\nAté 850 kg por nível.\\nTAMPOS DE AGLOMERADO DE 19 MM INCLUÍDOS"
    },
    "features": {
      "feature_Estante de carga média com capacidade de carga extra.": {
        "en": "Estante de carga média com capacidade de carga extra.",
        "es": "Estante de carga média com capacidade de carga extra.",
        "de": "Estante de carga média com capacidade de carga extra.",
        "it": "Estante de carga média com capacidade de carga extra."
      },
      "feature_Até 850 kg por nível.": {
        "en": "Até 850 kg por nível.",
        "es": "Até 850 kg por nível.",
        "de": "Até 850 kg por nível.",
        "it": "Até 850 kg por nível."
      },
      "feature_TAMPOS DE AGLOMERADO DE 19 MM INCLUÍDOS": {
        "en": "TAMPOS DE AGLOMERADO DE 19 MM INCLUÍDOS",
        "es": "TAMPOS DE AGLOMERADO DE 19 MM INCLUÍDOS",
        "de": "TAMPOS DE AGLOMERADO DE 19 MM INCLUÍDOS",
        "it": "TAMPOS DE AGLOMERADO DE 19 MM INCLUÍDOS"
      }
    },
    "categories": [
      "Medium Racks"
    ]
  },
  "9": {
    "name": {
      "en": "Medium Racks Z600",
      "es": "Medium Racks Z600",
      "de": "Medium Racks Z600",
      "it": "Medium Racks Z600"
    },
    "description": {
      "en": "A solução perfeita para armazenar e organizar cargas pesadas com segurança e eficiência. Com sua qualidade superior e design robusto, o Porteco Z60 atende às necessidades de empresas dos mais diversos setores.\\nCada nível foi projetado para suportar até 475 kg, garantindo a estabilidade e segurança do seu gado. Quer você armazene produtos industriais, materiais pesados ​​ou equipamentos, o Porteco Z60 é a solução confiável para o seu negócio.\\nTAMPOS DE AGLOMERADO DE 19 MM INCLUÍDOS\\nUma solução para armazenar mercadorias muito pesadas e volumosas.",
      "es": "A solução perfeita para armazenar e organizar cargas pesadas com segurança e eficiência. Com sua qualidade superior e design robusto, o Porteco Z60 atende às necessidades de empresas dos mais diversos setores.\\nCada nível foi projetado para suportar até 475 kg, garantindo a estabilidade e segurança do seu gado. Quer você armazene produtos industriais, materiais pesados ​​ou equipamentos, o Porteco Z60 é a solução confiável para o seu negócio.\\nTAMPOS DE AGLOMERADO DE 19 MM INCLUÍDOS\\nUma solução para armazenar mercadorias muito pesadas e volumosas.",
      "de": "A solução perfeita para armazenar e organizar cargas pesadas com segurança e eficiência. Com sua qualidade superior e design robusto, o Porteco Z60 atende às necessidades de empresas dos mais diversos setores.\\nCada nível foi projetado para suportar até 475 kg, garantindo a estabilidade e segurança do seu gado. Quer você armazene produtos industriais, materiais pesados ​​ou equipamentos, o Porteco Z60 é a solução confiável para o seu negócio.\\nTAMPOS DE AGLOMERADO DE 19 MM INCLUÍDOS\\nUma solução para armazenar mercadorias muito pesadas e volumosas.",
      "it": "A solução perfeita para armazenar e organizar cargas pesadas com segurança e eficiência. Com sua qualidade superior e design robusto, o Porteco Z60 atende às necessidades de empresas dos mais diversos setores.\\nCada nível foi projetado para suportar até 475 kg, garantindo a estabilidade e segurança do seu gado. Quer você armazene produtos industriais, materiais pesados ​​ou equipamentos, o Porteco Z60 é a solução confiável para o seu negócio.\\nTAMPOS DE AGLOMERADO DE 19 MM INCLUÍDOS\\nUma solução para armazenar mercadorias muito pesadas e volumosas."
    },
    "features": {
      "feature_A solução perfeita para armazenar e organizar cargas pesadas com segurança e eficiência. Com sua qualidade superior e design robusto, o Porteco Z60 atende às necessidades de empresas dos mais diversos setores.": {
        "en": "A solução perfeita para armazenar e organizar cargas pesadas com segurança e eficiência. Com sua qualidade superior e design robusto, o Porteco Z60 atende às necessidades de empresas dos mais diversos setores.",
        "es": "A solução perfeita para armazenar e organizar cargas pesadas com segurança e eficiência. Com sua qualidade superior e design robusto, o Porteco Z60 atende às necessidades de empresas dos mais diversos setores.",
        "de": "A solução perfeita para armazenar e organizar cargas pesadas com segurança e eficiência. Com sua qualidade superior e design robusto, o Porteco Z60 atende às necessidades de empresas dos mais diversos setores.",
        "it": "A solução perfeita para armazenar e organizar cargas pesadas com segurança e eficiência. Com sua qualidade superior e design robusto, o Porteco Z60 atende às necessidades de empresas dos mais diversos setores."
      },
      "feature_Cada nível foi projetado para suportar até 475 kg, garantindo a estabilidade e segurança do seu gado. Quer você armazene produtos industriais, materiais pesados ​​ou equipamentos, o Porteco Z60 é a solução confiável para o seu negócio.": {
        "en": "Cada nível foi projetado para suportar até 475 kg, garantindo a estabilidade e segurança do seu gado. Quer você armazene produtos industriais, materiais pesados ​​ou equipamentos, o Porteco Z60 é a solução confiável para o seu negócio.",
        "es": "Cada nível foi projetado para suportar até 475 kg, garantindo a estabilidade e segurança do seu gado. Quer você armazene produtos industriais, materiais pesados ​​ou equipamentos, o Porteco Z60 é a solução confiável para o seu negócio.",
        "de": "Cada nível foi projetado para suportar até 475 kg, garantindo a estabilidade e segurança do seu gado. Quer você armazene produtos industriais, materiais pesados ​​ou equipamentos, o Porteco Z60 é a solução confiável para o seu negócio.",
        "it": "Cada nível foi projetado para suportar até 475 kg, garantindo a estabilidade e segurança do seu gado. Quer você armazene produtos industriais, materiais pesados ​​ou equipamentos, o Porteco Z60 é a solução confiável para o seu negócio."
      },
      "feature_TAMPOS DE AGLOMERADO DE 19 MM INCLUÍDOS": {
        "en": "TAMPOS DE AGLOMERADO DE 19 MM INCLUÍDOS",
        "es": "TAMPOS DE AGLOMERADO DE 19 MM INCLUÍDOS",
        "de": "TAMPOS DE AGLOMERADO DE 19 MM INCLUÍDOS",
        "it": "TAMPOS DE AGLOMERADO DE 19 MM INCLUÍDOS"
      },
      "feature_Uma solução para armazenar mercadorias muito pesadas e volumosas.": {
        "en": "Uma solução para armazenar mercadorias muito pesadas e volumosas.",
        "es": "Uma solução para armazenar mercadorias muito pesadas e volumosas.",
        "de": "Uma solução para armazenar mercadorias muito pesadas e volumosas.",
        "it": "Uma solução para armazenar mercadorias muito pesadas e volumosas."
      }
    },
    "categories": [
      "Medium Racks"
    ]
  },
  "10": {
    "name": {
      "en": "Lite Racks",
      "es": "Lite Racks",
      "de": "Lite Racks",
      "it": "Lite Racks"
    },
    "description": {
      "en": "Estante de carga leve multifuncional.\\nAltamente versátil e funcional, oferece soluções que vão desde a seleção leve até o arquivamento especializado.\\nAté 198 kg por nível.\\nTampos não incluídos",
      "es": "Estante de carga leve multifuncional.\\nAltamente versátil e funcional, oferece soluções que vão desde a seleção leve até o arquivamento especializado.\\nAté 198 kg por nível.\\nTampos não incluídos",
      "de": "Estante de carga leve multifuncional.\\nAltamente versátil e funcional, oferece soluções que vão desde a seleção leve até o arquivamento especializado.\\nAté 198 kg por nível.\\nTampos não incluídos",
      "it": "Estante de carga leve multifuncional.\\nAltamente versátil e funcional, oferece soluções que vão desde a seleção leve até o arquivamento especializado.\\nAté 198 kg por nível.\\nTampos não incluídos"
    },
    "features": {
      "feature_Estante de carga leve multifuncional.": {
        "en": "Estante de carga leve multifuncional.",
        "es": "Estante de carga leve multifuncional.",
        "de": "Estante de carga leve multifuncional.",
        "it": "Estante de carga leve multifuncional."
      },
      "feature_Altamente versátil e funcional, oferece soluções que vão desde a seleção leve até o arquivamento especializado.": {
        "en": "Altamente versátil e funcional, oferece soluções que vão desde a seleção leve até o arquivamento especializado.",
        "es": "Altamente versátil e funcional, oferece soluções que vão desde a seleção leve até o arquivamento especializado.",
        "de": "Altamente versátil e funcional, oferece soluções que vão desde a seleção leve até o arquivamento especializado.",
        "it": "Altamente versátil e funcional, oferece soluções que vão desde a seleção leve até o arquivamento especializado."
      },
      "feature_Até 198 kg por nível.": {
        "en": "Até 198 kg por nível.",
        "es": "Até 198 kg por nível.",
        "de": "Até 198 kg por nível.",
        "it": "Até 198 kg por nível."
      },
      "feature_Tampos não incluídos": {
        "en": "Tampos não incluídos",
        "es": "Tampos não incluídos",
        "de": "Tampos não incluídos",
        "it": "Tampos não incluídos"
      }
    },
    "categories": [
      "Lite Racks"
    ]
  },
  "11": {
    "name": {
      "en": "Lite Racks Plus",
      "es": "Lite Racks Plus",
      "de": "Lite Racks Plus",
      "it": "Lite Racks Plus"
    },
    "description": {
      "en": "Estante de carga leve com capacidade de carga adicional.\\nMuito versátil e resistente. Uma solução inteligente para armazenar mercadorias pesadas e volumosas em espaços pequenos.\\nAté 303 kg por nível.\\nTampos não incluídos.",
      "es": "Estante de carga leve com capacidade de carga adicional.\\nMuito versátil e resistente. Uma solução inteligente para armazenar mercadorias pesadas e volumosas em espaços pequenos.\\nAté 303 kg por nível.\\nTampos não incluídos.",
      "de": "Estante de carga leve com capacidade de carga adicional.\\nMuito versátil e resistente. Uma solução inteligente para armazenar mercadorias pesadas e volumosas em espaços pequenos.\\nAté 303 kg por nível.\\nTampos não incluídos.",
      "it": "Estante de carga leve com capacidade de carga adicional.\\nMuito versátil e resistente. Uma solução inteligente para armazenar mercadorias pesadas e volumosas em espaços pequenos.\\nAté 303 kg por nível.\\nTampos não incluídos."
    },
    "features": {
      "feature_Estante de carga leve com capacidade de carga adicional.": {
        "en": "Estante de carga leve com capacidade de carga adicional.",
        "es": "Estante de carga leve com capacidade de carga adicional.",
        "de": "Estante de carga leve com capacidade de carga adicional.",
        "it": "Estante de carga leve com capacidade de carga adicional."
      },
      "feature_Muito versátil e resistente. Uma solução inteligente para armazenar mercadorias pesadas e volumosas em espaços pequenos.": {
        "en": "Muito versátil e resistente. Uma solução inteligente para armazenar mercadorias pesadas e volumosas em espaços pequenos.",
        "es": "Muito versátil e resistente. Uma solução inteligente para armazenar mercadorias pesadas e volumosas em espaços pequenos.",
        "de": "Muito versátil e resistente. Uma solução inteligente para armazenar mercadorias pesadas e volumosas em espaços pequenos.",
        "it": "Muito versátil e resistente. Uma solução inteligente para armazenar mercadorias pesadas e volumosas em espaços pequenos."
      },
      "feature_Até 303 kg por nível.": {
        "en": "Até 303 kg por nível.",
        "es": "Até 303 kg por nível.",
        "de": "Até 303 kg por nível.",
        "it": "Até 303 kg por nível."
      },
      "feature_Tampos não incluídos.": {
        "en": "Tampos não incluídos.",
        "es": "Tampos não incluídos.",
        "de": "Tampos não incluídos.",
        "it": "Tampos não incluídos."
      }
    },
    "categories": [
      "Lite Racks"
    ]
  },
  "12": {
    "name": {
      "en": "Lite Racks prateleiras inclinadas",
      "es": "Lite Racks prateleiras inclinadas",
      "de": "Lite Racks prateleiras inclinadas",
      "it": "Lite Racks prateleiras inclinadas"
    },
    "description": {
      "en": "As prateleiras inclinadas são a solução ideal para guardar pequenos objetos e melhorar o acesso ao produto a nível visual e prático.",
      "es": "As prateleiras inclinadas são a solução ideal para guardar pequenos objetos e melhorar o acesso ao produto a nível visual e prático.",
      "de": "As prateleiras inclinadas são a solução ideal para guardar pequenos objetos e melhorar o acesso ao produto a nível visual e prático.",
      "it": "As prateleiras inclinadas são a solução ideal para guardar pequenos objetos e melhorar o acesso ao produto a nível visual e prático."
    },
    "features": {
      "feature_As prateleiras inclinadas são a solução ideal para guardar pequenos objetos e melhorar o acesso ao produto a nível visual e prático.": {
        "en": "As prateleiras inclinadas são a solução ideal para guardar pequenos objetos e melhorar o acesso ao produto a nível visual e prático.",
        "es": "As prateleiras inclinadas são a solução ideal para guardar pequenos objetos e melhorar o acesso ao produto a nível visual e prático.",
        "de": "As prateleiras inclinadas são a solução ideal para guardar pequenos objetos e melhorar o acesso ao produto a nível visual e prático.",
        "it": "As prateleiras inclinadas são a solução ideal para guardar pequenos objetos e melhorar o acesso ao produto a nível visual e prático."
      }
    },
    "categories": [
      "Lite Racks"
    ]
  },
  "13": {
    "name": {
      "en": "Heavy Racks Plus",
      "es": "Heavy Racks Plus",
      "de": "Heavy Racks Plus",
      "it": "Heavy Racks Plus"
    },
    "description": {
      "en": "Estante de carga pesada multifuncional.\\nAltamente versátil e funcional, oferece soluções que vão desde a seleção leve até o arquivamento especializado.\\nA partir de  1000kg por nível.\\nTampos não incluídos",
      "es": "Estante de carga pesada multifuncional.\\nAltamente versátil e funcional, oferece soluções que vão desde a seleção leve até o arquivamento especializado.\\nA partir de  1000kg por nível.\\nTampos não incluídos",
      "de": "Estante de carga pesada multifuncional.\\nAltamente versátil e funcional, oferece soluções que vão desde a seleção leve até o arquivamento especializado.\\nA partir de  1000kg por nível.\\nTampos não incluídos",
      "it": "Estante de carga pesada multifuncional.\\nAltamente versátil e funcional, oferece soluções que vão desde a seleção leve até o arquivamento especializado.\\nA partir de  1000kg por nível.\\nTampos não incluídos"
    },
    "features": {
      "feature_Aplicações diversas. Preço sob orçamento.": {
        "en": "Aplicações diversas. Preço sob orçamento.",
        "es": "Aplicações diversas. Preço sob orçamento.",
        "de": "Aplicações diversas. Preço sob orçamento.",
        "it": "Aplicações diversas. Preço sob orçamento."
      }
    },
    "categories": [
      "Heavy Racks"
    ]
  },
  "14": {
    "name": {
      "en": "Mezzanines",
      "es": "Mezzanines",
      "de": "Mezzanines",
      "it": "Mezzanines"
    },
    "description": {
      "en": "mezanino de armazém\" ou \"mezanino de aço industrial\", para aumentar o tráfego orgânico, frequentemente visando setores com espaço limitado. \"piso de mezanino industrial\", \"sistemas de mezanino para armazéns\", \"plataformas de mezanino de aço\", \"corrimãos de mezanino\", \"escada de mezanino\", \"sistemas de estanteria para paletes\", \"mezaninos de escritórios\", \"mezaninos de lojas\", \"mezaninos de armazenamento",
      "es": "mezanino de armazém\" ou \"mezanino de aço industrial\", para aumentar o tráfego orgânico, frequentemente visando setores com espaço limitado. \"piso de mezanino industrial\", \"sistemas de mezanino para armazéns\", \"plataformas de mezanino de aço\", \"corrimãos de mezanino\", \"escada de mezanino\", \"sistemas de estanteria para paletes\", \"mezaninos de escritórios\", \"mezaninos de lojas\", \"mezaninos de armazenamento",
      "de": "mezanino de armazém\" ou \"mezanino de aço industrial\", para aumentar o tráfego orgânico, frequentemente visando setores com espaço limitado. \"piso de mezanino industrial\", \"sistemas de mezanino para armazéns\", \"plataformas de mezanino de aço\", \"corrimãos de mezanino\", \"escada de mezanino\", \"sistemas de estanteria para paletes\", \"mezaninos de escritórios\", \"mezaninos de lojas\", \"mezaninos de armazenamento",
      "it": "mezanino de armazém\" ou \"mezanino de aço industrial\", para aumentar o tráfego orgânico, frequentemente visando setores com espaço limitado. \"piso de mezanino industrial\", \"sistemas de mezanino para armazéns\", \"plataformas de mezanino de aço\", \"corrimãos de mezanino\", \"escada de mezanino\", \"sistemas de estanteria para paletes\", \"mezaninos de escritórios\", \"mezaninos de lojas\", \"mezaninos de armazenamento"
    },
    "features": {
      "feature_mezanino de armazém\" ou \"mezanino de aço industrial\", para aumentar o tráfego orgânico, frequentemente visando setores com espaço limitado. \"piso de mezanino industrial\", \"sistemas de mezanino para armazéns\", \"plataformas de mezanino de aço\", \"corrimãos de mezanino\", \"escada de mezanino\", \"sistemas de estanteria para paletes\", \"mezaninos de escritórios\", \"mezaninos de lojas\", \"mezaninos de armazenamento": {
        "en": "mezanino de armazém\" ou \"mezanino de aço industrial\", para aumentar o tráfego orgânico, frequentemente visando setores com espaço limitado. \"piso de mezanino industrial\", \"sistemas de mezanino para armazéns\", \"plataformas de mezanino de aço\", \"corrimãos de mezanino\", \"escada de mezanino\", \"sistemas de estanteria para paletes\", \"mezaninos de escritórios\", \"mezaninos de lojas\", \"mezaninos de armazenamento",
        "es": "mezanino de armazém\" ou \"mezanino de aço industrial\", para aumentar o tráfego orgânico, frequentemente visando setores com espaço limitado. \"piso de mezanino industrial\", \"sistemas de mezanino para armazéns\", \"plataformas de mezanino de aço\", \"corrimãos de mezanino\", \"escada de mezanino\", \"sistemas de estanteria para paletes\", \"mezaninos de escritórios\", \"mezaninos de lojas\", \"mezaninos de armazenamento",
        "de": "mezanino de armazém\" ou \"mezanino de aço industrial\", para aumentar o tráfego orgânico, frequentemente visando setores com espaço limitado. \"piso de mezanino industrial\", \"sistemas de mezanino para armazéns\", \"plataformas de mezanino de aço\", \"corrimãos de mezanino\", \"escada de mezanino\", \"sistemas de estanteria para paletes\", \"mezaninos de escritórios\", \"mezaninos de lojas\", \"mezaninos de armazenamento",
        "it": "mezanino de armazém\" ou \"mezanino de aço industrial\", para aumentar o tráfego orgânico, frequentemente visando setores com espaço limitado. \"piso de mezanino industrial\", \"sistemas de mezanino para armazéns\", \"plataformas de mezanino de aço\", \"corrimãos de mezanino\", \"escada de mezanino\", \"sistemas de estanteria para paletes\", \"mezaninos de escritórios\", \"mezaninos de lojas\", \"mezaninos de armazenamento"
      }
    },
    "categories": [
      "mezzanines"
    ]
  },
  "15": {
    "name": {
      "en": "Drive In",
      "es": "Drive In",
      "de": "Drive In",
      "it": "Drive In"
    },
    "description": {
      "en": "Soluções por medida para Sistema Estanteria Industrial de Drive IN",
      "es": "Soluções por medida para Sistema Estanteria Industrial de Drive IN",
      "de": "Soluções por medida para Sistema Estanteria Industrial de Drive IN",
      "it": "Soluções por medida para Sistema Estanteria Industrial de Drive IN"
    },
    "features": {
      "feature_Soluções por medida para Sistema Estanteria Industrial de Drive IN": {
        "en": "Soluções por medida para Sistema Estanteria Industrial de Drive IN",
        "es": "Soluções por medida para Sistema Estanteria Industrial de Drive IN",
        "de": "Soluções por medida para Sistema Estanteria Industrial de Drive IN",
        "it": "Soluções por medida para Sistema Estanteria Industrial de Drive IN"
      }
    },
    "categories": [
      "Sistema Estanteria Industrial de Drive IN"
    ]
  }
},

  // Category translations (by DATABASE category slug - as returned by API)
  categories: {
  "Racks de Canto": {
    "en": "Corner Racks",
    "es": "Racks de Esquina",
    "de": "Eckregale",
    "it": "Rack Angolari"
  },
  "Heavy Racks": {
    "en": "Heavy Duty Racks",
    "es": "Racks de Carga Pesada",
    "de": "Schwerlastregale",
    "it": "Rack per Carichi Pesanti"
  },
  "Medium Racks": {
    "en": "Medium-Duty Racks",
    "es": "Racks de Carga Media",
    "de": "Mittelastregale",
    "it": "Rack a Carico Medio"
  },
  "mezzanines": {
    "en": "Mezzanines",
    "es": "Entrepianos",
    "de": "Mezzanine",
    "it": "Soppalchi"
  },
  "Lite Racks": {
    "en": "Light-Duty Racks",
    "es": "Racks de Carga Ligera",
    "de": "Leichtlastregale",
    "it": "Rack a Carico Leggero"
  },
  "bancada-de-trabalho": {
    "en": "Workbenches",
    "es": "Bancos de Trabajo",
    "de": "Arbeitstische",
    "it": "Banchi da Lavoro"
  },
  "Sistema Estanteria Industrial de Drive IN": {
    "en": "Drive-In Racking",
    "es": "Estanterías Drive-In",
    "de": "Drive-In-Regale",
    "it": "Scaffalature Drive-In"
  }
},
};

export function getProductTranslation(productId, fieldName, language, defaultValue) {
  // Check product-specific translations first
  const productTrans = productTranslations.products[productId];
  if (productTrans && productTrans[fieldName] && productTrans[fieldName][language]) {
    return productTrans[fieldName][language];
  }

  // Check generic field translations
  const fieldTrans = productTranslations.fields[defaultValue];
  if (fieldTrans && fieldTrans[language]) {
    return fieldTrans[language];
  }

  // Check category translations
  if (fieldName === "category" && productTranslations.categories[defaultValue]) {
    return productTranslations.categories[defaultValue][language] || defaultValue;
  }

  return defaultValue;
}

export function getCategoryTranslation(slug, language) {
  const cat = productTranslations.categories[slug];
  return cat?.[language] || slug;
}

export function translateProduct(product, language) {
  if (language === "pt" || !product) return product;

  const productId = product.id || product.sku;

  return {
    ...product,
    name: getProductTranslation(productId, "name", language, product.name),
    description: getProductTranslation(productId, "description", language, product.description),
    sku: product.sku, // SKUs typically don't need translation
    features: product.features
      ? product.features.map((f) => getProductTranslation(productId, `feature_${f}`, language, f))
      : [],
    categories: product.categories?.map((cat) => ({
      ...cat,
      name: getCategoryTranslation(cat.slug, language) || cat.name,
    })) || [],
  };
}

export function translateVariant(variant, language, productId) {
  if (language === "pt" || !variant) return variant;

  const pid = productId || variant.product_id;

  return {
    ...variant,
    sku: variant.sku,
    is_next: variant.is_next,
    // Variant type is translated via the generic fields
  };
}
